module.exports = __webpack_public_path__ + "img/Edit.4d2c9c7b.png";